import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule, enableProdMode } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';

import { MetaModule } from '@ngx-meta/core';
import { SafePipe } from './safe.pipe';
import { MomentModule } from 'angular2-moment';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { LinkyModule } from 'angular-linky';
import { NgxPrintModule } from 'ngx-print';
import { TinymceModule } from 'angular2-tinymce';
import 'tinymce/plugins/paste/plugin.js';
import 'tinymce/plugins/print/plugin.js';
import 'tinymce/plugins/preview/plugin.js';
import 'tinymce/plugins/searchreplace/plugin.js';
import 'tinymce/plugins/autolink/plugin.js';
import 'tinymce/plugins/directionality/plugin.js';
import 'tinymce/plugins/visualblocks/plugin.js';
import 'tinymce/plugins/visualchars/plugin.js';
import 'tinymce/plugins/fullscreen/plugin.js';
import 'tinymce/plugins/image/plugin.js';
import 'tinymce/plugins/media/plugin.js';
import 'tinymce/plugins/template/plugin.js';
import 'tinymce/plugins/codesample/plugin.js';
import 'tinymce/plugins/charmap/plugin.js';
import 'tinymce/plugins/hr/plugin.js';
import 'tinymce/plugins/pagebreak/plugin.js';
import 'tinymce/plugins/nonbreaking/plugin.js';
import 'tinymce/plugins/anchor/plugin.js';
import 'tinymce/plugins/toc/plugin.js';
import 'tinymce/plugins/insertdatetime/plugin.js';
import 'tinymce/plugins/textcolor/plugin.js';
import 'tinymce/plugins/wordcount/plugin.js';
import 'tinymce/plugins/imagetools/plugin.js';
import 'tinymce/plugins/contextmenu/plugin.js';
import 'tinymce/plugins/colorpicker/plugin.js';
import 'tinymce/plugins/textpattern/plugin.js';
import 'tinymce/plugins/help/plugin.js';
import 'tinymce/plugins/emoticons/plugin.js';

import { AppServices } from './app.services';

import { NotifyService } from './addon/notify.service';
import { GravatarService } from './addon/gravatar.service';
import { GoogleAnalyticsService } from './addon/ga.service';
import { FirebaseService } from './addon/firebase.service';

import { AppComponent } from './app.component';
import { PageNotFoundComponent } from './not-found.component';

import { FcmComponent } from './fcm/fcm.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { HomeComponent } from './main/home/home.component';
import { ProfileComponent } from './main/profile/profile.component';
import { MyworksComponent } from './main/myworks/myworks.component';
import { AutocompleteComponent } from './shared/autocomplete/autocomplete.component';
import { MymessagesComponent } from './main/mymessages/mymessages.component';
import { LeadComponent } from './main/lead/lead.component';
import { ProposalComponent } from './main/proposal/proposal.component';
import { ContractComponent } from './main/contract/contract.component';
import { BillComponent } from './main/bill/bill.component';
import { TemplateComponent } from './main/template/template.component';
import { ProposalviewComponent } from './main/proposal/proposalview/proposalview.component';
import { CashflowComponent } from './main/cashflow/cashflow.component';

const appRoutes: Routes = [
{ path: '', component: AppComponent },
{ path: 'FCM_PLUGIN_ACTIVITY', component: FcmComponent },
{ path: 'main/home', component: HomeComponent },
{ path: 'main/profile/:code', component: ProfileComponent },
{ path: 'main/mw', component: MyworksComponent },
{ path: 'main/mm', component: MymessagesComponent },
{ path: 'main/lead', component: LeadComponent },
{ path: 'main/pp', component: ProposalComponent },
{ path: 'main/pv/:code', component: ProposalviewComponent },
{ path: 'main/contract', component: ContractComponent },
{ path: 'main/bill', component: BillComponent },
{ path: 'main/cashflow', component: CashflowComponent },
{ path: 'main/tpl', component: TemplateComponent },
{ path: '**', component: PageNotFoundComponent }
];

enableProdMode();

@NgModule({
  declarations: [
  AppComponent,
  PageNotFoundComponent,
  SafePipe,
  FcmComponent,
  HeaderComponent,
  FooterComponent,
  HomeComponent,
  ProfileComponent,
  MyworksComponent,
  AutocompleteComponent,
  MymessagesComponent,
  LeadComponent,
  ProposalComponent,
  ContractComponent,
  BillComponent,
  TemplateComponent,
  ProposalviewComponent,
  CashflowComponent
  ],
  imports: [
  BrowserModule,
  FormsModule,
  HttpModule,
  MomentModule,
  NgxJsonViewerModule,
  LinkyModule,
  NgxPrintModule,
  TinymceModule.withConfig({
    theme : 'modern',
    selector: '.tinymce',
    branding: false,
    resize: false,
    menubar: false,
    // inline: true,
    min_height: 300,
    forced_root_block : '',
    plugins: ['paste print preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor wordcount imagetools contextmenu colorpicker textpattern help emoticons code advlist'],
    toolbar: [
    'paste | formatselect | bold italic strikethrough forecolor backcolor | link | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent  | removeformat',
    'fullscreen emoticons | table list hr | image media | charmap code codesample | pagebreak print'
    ],
    paste_data_images: true,
    images_upload_handler: function (blobInfo, success, failure) {
      success("data:" + blobInfo.blob().type + ";base64," + blobInfo.base64());
    },
  }),
  RouterModule.forRoot(appRoutes),
  MetaModule.forRoot(),
  ],
  exports: [RouterModule],
  providers: [Title, AppServices, NotifyService, GravatarService, GoogleAnalyticsService, FirebaseService],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// D:/wamp/www/sportal/pmi/web/src/app/app.module.ts